import swal from 'sweetalert';
import $ from 'jquery';
import I18n from 'i18n-js';
import select2 from 'select2';
import 'javascripts/i18n/translations';
import {toastr} from './notifications';

I18n.locale = window.I18n.locale;

document.addEventListener("turbolinks:before-cache", function () {
    $('[data-toggle="m-tooltip"]').tooltip('hide');
    $('.selectpicker').selectpicker('destroy');
});

$(document).on('turbolinks:load', function () {
    $(document).ready(function () {
        $("#hide_show_video").click(function () {
            $("#video-tuto").toggle();
        });
    });

    function file_pdf() {

        var fileInput = document.getElementById("pdfFile");

        try {
            if (fileInput.files[0].size > 2000000) {
                swal({
                    title: "Archivo demasiado grande",
                    text: "El archivo debe pesar menos de 2mb",
                    icon: 'warning',
                    button: I18n.t('messages.ok')
                });

                document.getElementById("pdfFile").value = null;
            }
        } catch (e) {
            document.getElementById("pdfFile").value = null;
        }
    }


    // $('#pdfFile').on("change", file_pdf);

    $('#validateID').on('click', function () {
        swal({
            title: 'Espere un momento',
            text: 'Validando la factura',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            buttons: false,
            onOpen: function () {
                swal.showLoading()
            }
        });
        var xmlFile = document.getElementById("xmlFile").files[0];

        var pdfFile = document.getElementById("pdfFile").files[0];
        var basePdfFile;
        if (xmlFile === undefined  || pdfFile === undefined || xmlFile['type'] !== 'text/xml' ||
            pdfFile['type'] !== 'application/pdf'){
            swal({
                title: 'Es necesario adjuntar un archivo xml y un archivo pdf',
                text: '',
                icon: 'error',
                button: 'OK'
            }).then(function () {
                // location.reload()
            });

        }else{
            var readerPdf = new FileReader();
            readerPdf.readAsDataURL(pdfFile);

            readerPdf.onload = function(e) {

                basePdfFile = e.target.result;
            };

            var reader = new FileReader();
            reader.readAsText(xmlFile);
            reader.onload = function(e) {

                var readXml = e.target.result;
                $.ajax({
                    url: '/validate_xml',
                    data: {
                        xmlFile: readXml,
                        pdfFile: basePdfFile
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        if (data.message === '0 - Sin Errores.'){

                            document.getElementById("xmlFile").value = "";
                            document.getElementById("pdfFile").value = "";

                            swal({
                                title: data.message,
                                text: '',
                                icon: 'success',
                                button: 'OK'
                            }).then(function () {
                                location.reload()
                            });
                        }else{
                            document.getElementById("xmlFile").value = "";
                            document.getElementById("pdfFile").value = "";
                            swal({
                                title: data.message,
                                text: '',
                                icon: 'error',
                                button: 'OK'
                            }).then(function () {
                                // location.reload()
                            });
                        }
                    },
                    error: function (error) {
                        swal({
                            title:
                            'Sin comunicación con el servidor PAC.',
                            text: '',
                            icon: 'error',
                            button: 'OK'
                        }).then(function () {
                            // location.reload()
                        });
                    }
                });
            }
        }

    });

    window.validateComplement = function(facturaId){
        swal({
            title: 'Espere un momento',
            text: 'Validando la factura',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            buttons: false,
            onOpen: function () {
                swal.showLoading()
            }
        });
        var xmlFile = document.getElementById("xmlFile"+facturaId).files[0];
        var pdfFileComplemento = document.getElementById("pdfFile"+facturaId).files[0];
        //var basePdfFileComplemento = null;
        var baseXMLFileComplemento = null;

        if (xmlFile === undefined  || pdfFileComplemento === undefined || xmlFile['type'] !== 'text/xml' ||
            pdfFileComplemento['type'] !== 'application/pdf'){
            swal({
                title: 'Es necesario adjuntar un archivo xml y un archivo pdf',
                text: '',
                icon: 'error',
                button: 'OK'
            }).then(function () {
                // location.reload()
            });

        }else{
            var reader = new FileReader();
            reader.readAsText(xmlFile);
            reader.onload = function(e) {
                baseXMLFileComplemento = e.target.result;
            }

            var readerPdfComplemento = new FileReader();
            readerPdfComplemento.readAsDataURL(pdfFileComplemento);
            readerPdfComplemento.onload = function(e) {
                var basePdfFileComplemento = e.target.result;
                $.ajax({
                    url: '/validate_complement',
                    data: {
                        xmlFile: baseXMLFileComplemento,
                        pdfFile: basePdfFileComplemento,
                        facturaId: facturaId
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        if (data.message === '0 - Sin Errores.'){
                            document.getElementById("xmlFile"+facturaId).value = "";
                            document.getElementById("pdfFile"+facturaId).value = "";
                            swal({
                                title: data.message,
                                text: '',
                                icon: 'success',
                                button: 'OK'
                            }).then(function () {
                                location.reload()
                            });
                        }else{
                            document.getElementById("xmlFile"+facturaId).value = "";
                            document.getElementById("pdfFile"+facturaId).value = "";
                            swal({
                                title: data.message,
                                text: '',
                                icon: 'error',
                                button: 'OK'
                            }).then(function () {

                                // location.reload()
                            });
                        }
                    },
                    error: function (error) {
                        var basePdfFileComplemento = null;
                        swal({
                            title:
                                'Sin comunicación con el servidor PAC.(JS)',
                            text: '',
                            icon: 'error',
                            button: 'OK'
                        }).then(function () {
                            // location.reload()
                        });
                    }
                });
            }
        }
    }

    window.validateXmlOrden = function(ordenId,ejercicio,pertenece,origen){
        swal({
            title: 'Espere un momento',
            text: 'Validando la factura',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            buttons: false,
            onOpen: function () {
                swal.showLoading()
            }
        });
        var xmlFile = document.getElementById("xmlFile"+ordenId).files[0];
        var pdfFileComplemento = document.getElementById("pdfFile"+ordenId).files[0];
        //var basePdfFileComplemento = null;
        var baseXMLFileComplemento = null;

        if (xmlFile === undefined  || pdfFileComplemento === undefined || xmlFile['type'] !== 'text/xml' ||
            pdfFileComplemento['type'] !== 'application/pdf'){
            swal({
                title: 'Es necesario adjuntar un archivo xml y un archivo pdf (Orden)' ,
                text: '',
                icon: 'error',
                button: 'OK'
            }).then(function () {
                // location.reload()
            });

        }else{
            var reader = new FileReader();
            reader.readAsText(xmlFile);
            reader.onload = function(e) {
                baseXMLFileComplemento = e.target.result;
            }

            var readerPdfComplemento = new FileReader();
            readerPdfComplemento.readAsDataURL(pdfFileComplemento);
            readerPdfComplemento.onload = function(e) {
                var basePdfFileComplemento = e.target.result;
                $.ajax({
                    url: '/validate_xml_orden',
                    data: {
                        xmlFile: baseXMLFileComplemento,
                        pdfFile: basePdfFileComplemento,
                        ordenId: ordenId,
                        ejercicio: ejercicio,
                        pertenece: pertenece,
                        origen: origen
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        if (data.message === '0 - Sin Errores.'){
                            document.getElementById("xmlFile"+ordenId).value = "";
                            document.getElementById("pdfFile"+ordenId).value = "";
                            swal({
                                title: data.message,
                                text: '',
                                icon: 'success',
                                button: 'OK'
                            }).then(function () {
                                location.reload()
                            });
                        }else{
                            document.getElementById("xmlFile"+ordenId).value = "";
                            document.getElementById("pdfFile"+ordenId).value = "";
                            swal({
                                title: data.message,
                                text: '',
                                icon: 'error',
                                button: 'OK'
                            }).then(function () {

                                // location.reload()
                            });
                        }
                    },
                    error: function (error) {
                        var basePdfFileComplemento = null;
                        swal({
                            title:
                                'Sin comunicación con el servidor PAC.',
                            text: '',
                            icon: 'error',
                            button: 'OK'
                        }).then(function () {
                            // location.reload()
                        });
                    }
                });
            }
        }
    }

    window.guardaDetalleRequi = function(iddRequi, idRequiProvvedor,cantidad){

        var valor = document.getElementById('valor_u'+iddRequi).value ;
        var subtotal = document.getElementById('subtotal'+iddRequi);
        subtotal.value = valor * cantidad ;
        var subtotal_val = document.getElementById('subtotal'+iddRequi).value;
        if (valor  > 0 ){
        $.ajax({
            url: '/guarda_detalle_requi',
            data: {
                iddRequi: iddRequi,
                idRequiProvvedor: idRequiProvvedor,
                valor: valor,
                subtotal_val: subtotal_val
            },
            type: 'POST',
            dataType: 'json',
            success: function (data) {},
            error: function (error) {
                var basePdfFileComplemento = null;
                swal({
                    title:
                        'Ah ocurrido un error. Favor de Capturar importe de nuevo',
                    text: '',
                    icon: 'error',
                    button: 'OK'
                }).then(function () {
                    // location.reload()
                });
            }
        });
    }
    }

    window.guardaCotizacion = function(requiId){
        swal({
            title: 'Espere un momento',
            text: 'Registrando Cotización',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            buttons: false,
            onOpen: function () {
                swal.showLoading()
            }
        });
        var pdfFileComplemento = document.getElementById("pdfFile"+requiId).files[0];
        var moneda = document.getElementById("moneda").value;
        var vigencia = document.getElementById("vigencia").value;
        var garantia = document.getElementById("garantia").value;
        var unidadgarantia = document.getElementById("unidadGarantia").value;
        var entrega = document.getElementById("entrega").value;
        var unidadentrega = document.getElementById("unidadEntrega").value;
        var iva = document.getElementById("iva").value;
        var notas = document.getElementById("notas").value;

        if (pdfFileComplemento === undefined  ||
            pdfFileComplemento['type'] !== 'application/pdf'){
            swal({
                title: 'Es necesario adjuntar un archivo pdf de Cotización' ,
                text: '',
                icon: 'error',
                button: 'OK'
            }).then(function () {
                // location.reload()
            });

        }else{

            var readerPdfComplemento = new FileReader();
            readerPdfComplemento.readAsDataURL(pdfFileComplemento);
            readerPdfComplemento.onload = function(e) {
                var basePdfFileComplemento = e.target.result;
                $.ajax({
                    url: '/guarda_cotizacion',
                    data: {
                        pdfFile: basePdfFileComplemento,
                        requiId: requiId,
                        moneda: moneda,
                        vigencia: vigencia,
                        garantia: garantia,
                        unidadgarantia: unidadgarantia,
                        entrega: entrega,
                        unidadentrega: unidadentrega,
                        iva: iva,
                        notas: notas
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        if (data.message === 'Cotización registrada con éxito'){
                            document.getElementById("pdfFile"+requiId).value = "";
                            swal({
                                title: data.message,
                                text: '',
                                icon: 'success',
                                button: 'OK'
                            }).then(function () {
                                location.replace("/requisiciones");
                            });
                        }else{
                            document.getElementById("pdfFile"+requiId).value = "";
                            swal({
                                title: data.message,
                                text: '',
                                icon: 'error',
                                button: 'OK'
                            }).then(function () {

                                // location.reload()
                            });
                        }
                    },
                    error: function (error) {
                        var basePdfFileComplemento = null;
                        swal({
                            title:
                                'Ah Ocurrido un error al guardar Cotización',
                            text: '',
                            icon: 'error',
                            button: 'OK'
                        }).then(function () {
                            // location.reload()
                        });
                    }
                });
            }
        }
    }



});

let cascadeSelects = (source, destination, url) => {
    let ajaxRequest = (resource, edit) => {
        if (resource !== '') {
            $.get(url, {resource: resource}, function (data) {
                destination.empty();
                if (data.length > 0) {
                    for (let action of data) {
                        destination.append($('<option>', {value: action[0], text: action[1]}));
                    }
                    edit && destination.val(destination.data('value'));
                } else {
                    destination.append($('<option>', {value: '', text: I18n.t('helpers.select.no_options')}));
                }
                $('.selectpicker').selectpicker('refresh');
            })
                .fail(function () {
                    toastr.warning(I18n.t('messages.try_again'));
                });
        }
    };

    ajaxRequest(source.val(), true);

    source.on('change', function (e) {
        let resource = $(e.target).val();
        ajaxRequest(resource, false);
    });
};

//SOLO NUMEROS
$(function(){
    $(".numerico").keydown(function(event){
        //alert(event.keyCode);
        if((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105) && event.keyCode !==190  && event.keyCode !==110 && event.keyCode !==8 && event.keyCode !==9  ){
            return false;
        }
    });
});



export {cascadeSelects};


